export default __webpack_public_path__ + "static/media/sydney-nye.46a5de24.jpg";